import React from 'react';
import { Icon } from 'semantic-ui-react';
import { shape, number } from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { fetchSettings } from 'Helpers/utils';

const GoogleMapMaker = ({ lat, lng }) => <Icon size="big" color="red" name="map marker" lat={lat} lng={lng} />;

GoogleMapMaker.propTypes = {
  lat: number.isRequired,
  lng: number.isRequired,
};

const MessageLocation = ({ message }) => {
  const { attachment: { coordinates: { lat, long } } } = message.message;
  const center = {
    lat,
    lng: long,
  };
  const zoom = 14;
  const globSettings = fetchSettings() || {};

  return (
    <div style={{ height: 300, width: 300 }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: globSettings.GOOGLE_API_KEY }}
        defaultCenter={center}
        defaultZoom={zoom}
      >
        <GoogleMapMaker lat={lat} lng={long} />
      </GoogleMapReact>
    </div>
  );
};

MessageLocation.propTypes = {
  message: shape({}).isRequired,
};

MessageLocation.defaultProps = {
};

export default MessageLocation;
